"use client";
import Image from "next/image";
import styles from "./ScholarshipBenefits.module.scss";
import { useModalDispatch } from "@/context/ModalContext";
import { IModalActions, ModalTypes } from "@/types/modal";
import React from "react";

const ScholarshipBenefits = ({ Benefits, associatedPrograms }: any) => {
  const modalDispatch = useModalDispatch();

  const handleApplyNow = () => {
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.ConnectModalV2,
        modalData: {
          isLandingPage: true,
          isScholarShipPage: true,
          associatedPrograms,
          heading: "Join India's No. 1 Online University",
          submitBtnText: "Apply Now",
        },
      },
    });
  };

  return (
    <section className={styles.section}>
      <div className={styles.bannerCard}>
        <Image
          src={Benefits?.BgImage?.url}
          alt="Scholarship Benefits"
          fill
          className={styles.bgImage}
        />

        <div className={styles.content}>
          <h2
            className={styles.heading}
            dangerouslySetInnerHTML={{
              __html: Benefits?.TitleCk.replace(/<\/?p>/gi, "") || "",
            }}
          ></h2>
          <p className={styles.description}>{Benefits?.Description}</p>

          <button className={styles.ctaButton} onClick={handleApplyNow}>
            {Benefits?.CTA}
            <Image
              src="https://static-studyabroad.amityonline.com/dev/left_arrow1_6f872732a3.svg"
              alt=""
              width={20}
              height={20}
            />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ScholarshipBenefits;
